import React from 'react';

import Link from 'next/link';
import ProficiencyBadge from '@core/components/proficiencybadge/ProficiencyBadge';

import TickIcon from 'assets/icons/tick-blank.svg';

import classes from './AssessmentCard.module.scss';



const AssessmentCard = ({ data, isSmall = false }) => {
    return (
        <Link href={`/assessments/${data?.id}/${data?.slug}`}>
            <div className={`${classes['wrapper']} ${isSmall ? classes['small'] : ''}`}>
                <img src={data?.image} alt={data?.title} />
                <div className={classes['content']}>
                    <h3>{data?.title}</h3>
                    <p>{data?.short_introduction}</p>
                    <div className='d-flex justify-content-between align-items-center'>
                        {(data?.last_status && data?.last_status === 'passed') ? (
                            <span className={classes['passed']}><TickIcon /> Passed</span>
                        ) : (
                            <span>{data?.question_count} questions</span>
                        )}
                        <ProficiencyBadge proficiency={data?.proficiency} />
                       
                    </div>

                </div>
            </div>
        </Link>
    );
};

export default AssessmentCard;